<template>
  <div class="courses">
    <div class="filter-area">
      <div class="container">
        <el-breadcrumb class="breadcrumb pc" separator=">">
          <el-breadcrumb-item :to="{ path: '../../hnkc/portal' }"> <i class="iconfont iconyemiandaohang-shouye"></i>首页 </el-breadcrumb-item>
          <el-breadcrumb-item>通识教育课程</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>{{ menutitle[declareType] }}</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div class="container container-filter" v-if="showMoreFilter">
        <typeFilter class="filter-item" name="学科/专业" valName="subjectDefaultType" wholeTypeName="全部" :types="subjects" :defaultType="subjectDefaultType" @type-change="handleTypeChange" />
        <!-- <typeFilter class="filter-item" name="认定级别" valName="levelDefaultType" 
        wholeTypeName="全部" :types="levels" :defaultType="levelDefaultType" @type-change="handleTypeChange" /> -->
        <typeFilter class="filter-item" name="课程分类" valName="courseDefaultType" wholeTypeName="全部" :types="courseTypes" :defaultType="courseDefaultType" @type-change="handleTypeChange" />
        <typeFilter class="filter-item" name="课程平台" valName="platformDefaultType" wholeTypeName="全部" :types="platforms" :defaultType="platformDefaultType" @type-change="handleTypeChange" />
      </div>
    </div>
    <div class="container content">
      <div class="mobile">
        <el-row>
          <el-col :xs="24" :sm="0">
            <div class="filter-title">申报学校：</div>
            <div class="choose-school-wra">
              <i class="el-icon-caret-bottom right-ico"></i>
              <el-select v-model="currentSchoolValue" filterable @change="handleTypeChange(currentSchoolValue, 'currentSchoolValue')" placeholder="全部学校">
                <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pc">
        <el-row>
          <el-col :xs="0" :sm="24">
            <span class="total-num">共 <span>{{ total }}</span> 门课程</span>
            <div v-if="this.declareType == 1">
              <div class="filter-title">申报学校：</div>
              <div class="choose-school-wra">
                <i class="el-icon-caret-bottom right-ico"></i>
                <el-select v-model="currentSchoolValue" filterable @change="handleTypeChange(currentSchoolValue, 'currentSchoolValue')" placeholder="全部学校">
                  <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </div>
            </div>
            <div class="clearfix right-area">
              <div class="search-course">
                <span class="input-name">专业</span>
                <el-input v-model="subjectName" placeholder="请输入专业名称" @keyup.enter.native="getCourseList"></el-input>
                <span class="input-name">学校</span>
                <el-input v-model="schoolWord" placeholder="请输入学校名称" @keyup.enter.native="getCourseList"></el-input>
                <span class="input-name">教师</span>
                <el-input v-model="teaWord" placeholder="请输入教师名称" @keyup.enter.native="getCourseList"></el-input>
                <el-button class="search-ico" type="danger" @click="getCourseList">搜索</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="course-list" v-loading="loading">
        <el-row :gutter="32">
          <el-col :xs="12" :sm="6" v-for="(item, index) in courses" :key="index">
            <div class="course-item card-shadow has-hover can-click hover-bigger" :class="{ first: index === 0 }" @click="viewCourse(item)">
              <div class="cover-wrapper">
                <div v-if="item.level" class="course-level" :class="'level-' + item.level">{{ levelMap[item.level] }}</div>
                <el-image class="cover" fit="cover" :src="item.cover">
                  <div slot="error" class="default-img">
                    <i class="iconfont iconjiaocaizhanwei"></i>
                  </div>
                </el-image>
              </div>
              <div class="course-info">
                <h1 class="name">{{ item.name }}</h1>
                <div class="creator">
                  <div>
                    <span class="teacher-name">{{ item.orgName }}</span> |
                    <span class="teacher-name">{{ item.masterName }}</span>
                  </div>
                  <div>
                    <span class="teacher-name">课程访问量：{{ item.visitCount }}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total"
          :hide-on-single-page="true"
        ></el-pagination>

        <!-- <div class="empty-tip" v-if="courses.length === 0">-暂无数据-</div> -->
        <div v-if="!total" class="no-course">
          <i class="iconfont iconmhweikong"></i>
          <div>暂无课程</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import typeFilter from '../components/typeFilter.vue'
import { spocSchoolLevel, subjectList, orgList, platforms, courseClassifyList } from '@/api/api.js'

export default {
  name: 'courses',
  props: ['declareType'],
  data() {
    return {
      showMoreFilter: true,
      yearDefaultType: 0,
      levelDefaultType: 0,
      subjectDefaultType: 0,
      courseDefaultType: 0,
      platformDefaultType: 0,
      years: [],
      levels: [
        {
          id: 1,
          name: '国家级'
        },
        {
          id: 2,
          name: '省级'
        }
      ],
      courseTypes: [
        {
          id: 1,
          name: '文化素质课'
        },
        {
          id: 2,
          name: '公共基础课'
        },
        {
          id: 3,
          name: '专业课'
        }
      ],
      subjects: [
        {
          id: 1,
          name: '哲学'
        },
        {
          id: 2,
          name: '经济学'
        },
        {
          id: 3,
          name: '法学'
        }
      ],
      platforms: [],
      currentSchoolValue: null, // 当前所选学校
      schoolList: [
        {
          id: 0,
          name: '优学院1'
        },
        {
          id: 1,
          name: '优学院2'
        },
        {
          id: 2,
          name: '优学院3'
        }
      ],
      keyword: '',
      // activeName: "0",
      currentPage: 1,
      pageSize: 16,
      total: 0,
      courses: [],
      loading: false,
      menutitle: ['', '校级精品', ''],
      levelMap: {
        1: '国家级',
        2: '省级'
      },
      schoolWord: '',
      teaWord: '',
      subjectName: ''
    }
  },
  created() {
    this.getSubjectList()
    this.getOrgList()
    this.getCourseList()
    this.getPlatforms()
    this.getCourseClassifyList()
    for (let i = new Date().getFullYear(); i > 2015; i--) {
      this.years.push({
        id: i,
        name: i
      })
    }
  },
  watch: {
    $route() {
      this.subjectDefaultType = 0
      this.platformDefaultType = 0
      this.courseDefaultType = 0
      this.levelDefaultType = 0
      this.currentSchoolValue = null
      this.keyword = ''
      //监听路由是否变化，激活对应菜单
      this.getCourseList()
    }
  },
  methods: {
    getCourseClassifyList() {
      courseClassifyList()
        .then((res) => {
          this.courseTypes = res.result
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getSubjectList() {
      subjectList()
        .then((res) => {
          this.subjects = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getOrgList() {
      orgList()
        .then((res) => {
          this.schoolList = res
          this.schoolList.unshift({
            id: 0,
            name: '全部学校'
          })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getPlatforms() {
      platforms()
        .then((res) => {
          this.platforms = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getCourseList() {
      this.loading = true
      spocSchoolLevel({
        type: this.declareType,
        subjectId: this.subjectDefaultType || '',
        level: this.levelDefaultType || '',
        courseClassifyId: this.courseDefaultType || "",
        platformId: this.platformDefaultType || '',
        orgId: this.currentSchoolValue || '',
        subjectName: this.subjectName,
        teacher: this.teaWord,
        school: this.schoolWord,
        // type: this.activeName,
        queryKey: this.keyword,
        pn: this.currentPage,
        ps: this.pageSize
      })
        .then((res) => {
          // 返回数据
          this.total = res.result.total
          this.courses = res.result.list

          this.loading = false
        })
        .catch((err) => {
          // 异常情况
          console.log(err)
          this.loading = false
        })
    },
    handleCurrentChange() {
      this.getCourseList()
    },
    handleClick() {
      this.getCourseList()
    },
    handleTypeChange(val, type) {
      // this.currentType = val === 0 ? null : val;
      // this.yearDefaultType = val;
      this[type] = val
      console.log(val, type)
      this.getCourseList()
    },
    viewCourse(item) {
      if (this.declareType == 5) {
        window.open(item.courseUrl)
      } else {
        this.$router.push(`/hnkc/schoolLevelContent/${this.declareType}/${item.id}`)
      }
    }
  },
  components: {
    typeFilter
  }
}
</script>

<style scoped>
h1 {
  font-weight: normal;
  margin-bottom: 24px;
  font-size: 22px;
  line-height: 24px;
  color: #111;
}
.courses {
  background-color: #fff;
}
.more-filter-btn {
  font-size: 14px;
  color: #fc5d27;
  line-height: 20px;
  cursor: pointer;
}
.filter-item {
  padding: 10px 0;
}
.filter-area {
  padding: 10px 0 14px;
  font-size: 20px;
  color: #666;
  /* line-height: 34px; */
  background-color: #ffff;
  /* border-bottom: 1px solid #eee; */
}
.container-filter {
  background-color: #F7F7FD;
  padding: 10px 20px;
}
.content {
  margin-top: 30px;
  margin-bottom: 80px;
}

.tabs {
  margin-left: 24px;
  display: inline-block;
  vertical-align: bottom;
}

.course-list {
  margin-top: 30px;
}

.course-item {
  border: 1px solid #e5e5e5;
  margin-bottom: 20px;
  background-color: #fff;
}
.last-row-course .course-item {
  margin-bottom: 0;
}

.cover-wrapper {
  position: relative;
  padding-bottom: 56.25%;
}

.cover-wrapper .course-level {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  padding: 2px 4px;
  line-height: 20px;
  color: #fff;
  font-size: 14px;
  border-radius: 2px;
}
.course-level.level-1 {
  background-color: #009900;
}
.course-level.level-2 {
  background-color: #f99e16;
}
.course-level.level-3 {
  background-color: #50a6ff;
}

.cover-wrapper .cover {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #eee;
}

.course-item .course-info {
   padding: 10px 10px 16px 10px;
}

.course-item .name {
  height: 24px;
  line-height: 24px;
  font-size: 15px;
  margin-bottom: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.course-item .creator {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  height: 22px;
  line-height: 22px;
  font-size: 12px;
  color: #888;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.course-item .teacher-name {
  vertical-align: middle;
  max-width: 40%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.course-item .teacher-academy {
  /* float: right; */
  max-width: 50%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

@media (max-width: 767px) {
  .courses {
    background-color: #fff;
  }
  .filter-area {
    padding: 10px 0;
    margin-bottom: 15px;
    font-size: 14px;
    color: #666;
    border-bottom: none;
  }
  .filter-area .container {
    padding: 0;
  }
  .filter-item {
    width: 25%;
    display: inline-block;
    background-color: #fff;
    margin-top: -1px;
  }
  .content {
    margin-top: 0;
    margin-bottom: 30px;
  }

  .course-list {
    margin-top: 20px;
  }

  .course-item {
    margin-bottom: 0;
    padding: 0;
    border: none;
  }
  .course-item .course-info {
    min-height: 90px;
    padding: 8px 0;
  }
  .course-item .name {
    margin-bottom: 4px;
    height: auto;
    max-height: 42px;
    line-height: 21px;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .course-item .creator {
    margin-top: 0;
    height: auto;
    line-height: 20px;
  }
  .course-item .teacher-academy {
    float: none;
    display: block;
    width: 100%;
    max-width: 100%;
    margin-bottom: 4px;
  }
  .course-item .teacher-name {
    display: block;
    width: 100%;
    max-width: 100%;
  }

  .cover-wrapper .course-level {
    font-size: 12px;
    line-height: 16px;
  }

  .more-filter-btn {
    padding: 10px;
  }
}

.breadcrumb {
  margin-top: 20px;
  margin-bottom: 20px;
}

.breadcrumb .iconfont {
  margin-right: 2px;
  font-size: 14px;
}
</style>

<style lang="scss">
.courses {
  .el-tabs__header {
    margin: 0;
  }

  .el-tabs__nav-wrap::after {
    content: unset;
  }

  .el-tabs__item {
    height: 24px;
    font-size: 16px;
    line-height: 16px;
    color: #444;
  }

  .el-tabs__item:hover {
    color: #ec2f08;
  }

  .el-tabs__item.is-active {
    font-weight: bold;
    color: #ec2f08;
  }

  .el-tabs__active-bar {
    height: 3px;
    background-color: unset;
  }

  .el-tabs__active-bar:before {
    content: '';
    display: block;
    margin: auto;
    width: 12px;
    height: 100%;
    /* border-radius: 50%; */
    background-color: #ec2f08;
  }

  .filter-item .el-input__inner {
    border-radius: 0;
    border-left: none;
    border-right: none;
    background-color: #fff !important;
    padding: 0 30px 0 10px;
  }
  .filter-item .el-input__inner:focus,
  .is-focus .el-input__inner {
    border-color: #dcdfe6 !important;
  }

  .total-num {
    float: left;
    font-size: 18px;
    // font-weight: bold;
    margin-right: 30px;
    span {
      color: #7691ff;
    }
  }
  .search-course {
    position: relative;
    float: right;
    height: 36px;
    margin-top: -5px;
    border-radius: 4px;
    .input-name {
      margin: 0px 8px 0px 20px;
      font-size: 14px;
      color: #666;
    }
    .el-input {
      width: 200px;
    }
    .el-input__inner {
      height: 36px;
      padding: 10px;
      background-color: #fff !important;
      border: 1px solid #cdcde6;
    }
    .search-ico {
      width: 70px;
      margin-left: 20px;
      padding: 10px;
      text-align: center;
      color: #fff;
      background-color: #7691ff !important;
      border-color: #7691ff !important;
      cursor: pointer;
    }
  }

  .right-area {
    float: right;
  }

  .filter-title {
    // float: left;
    // font-size: 14px;
    // text-align: justify;
  }
  .choose-school-wra {
    float: left;
    width: 260px;
    // margin-left: 82px;
    position: relative;
    margin-top: -5px;
    margin-right: 10px;
    background-color: #fff;
    .el-select {
      display: block;
      width: 100%;
      .el-input__inner {
        height: 36px;
        border-color: #c5c5d3;
        background-color: transparent !important;
      }
      .el-input__suffix {
        display: none;
      }
    }
    .right-ico {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 0;
      width: 30px;
      line-height: 37px;
      text-align: center;
      color: #fff;
      background-color: #7691ff;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  .no-course {
    text-align: center;
    padding: 60px 10px;
    color: #999;
    .iconfont {
      display: inline-block;
      font-size: 60px;
      margin-bottom: 20px;
      color: #ddd;
    }
  }
}
.el-input__inner:focus {
  background-color: #fff;
  border-color: #7691FF !important;
}
</style>
